import { EStringOp } from '@src/emp-3.0/types';
import { IRuleGroup, IRuleItem } from '../RuleGroup/typed';

export enum EInputType {
  EVENT_NAME,
  KEY,
  VALUE,
  OPERATOR,
  METADATA_NAME,
  METADATA_OPERATOR,
  METADATA_VALUE,
}

export interface IProps {
  id?: string;
  disabled?: boolean;
  eventName?: IRuleGroup['eventName'];
  data: IRuleItem;
  active?: {
    key?: boolean;
    value?: boolean;
  };
  onChange: (type: EInputType, value: string) => void;
  onActiveChange: (type: EInputType, active: boolean) => void;
}

export const operatorOptions: {
  value: EStringOp;
  label: string;
}[] = Object.values(EStringOp).map((value) => ({
  value,
  label:
    {
      [EStringOp.EQ]: 'equals',
      [EStringOp.NOT_EQ]: 'not equals',
    }[value] || value,
}));

export const positiveOperatorOptions: {
  value: string;
  label: string;
}[] = [
  {
    value: EStringOp.EQ,
    label: 'equals',
  },
  {
    value: EStringOp.CONTAINS,
    label: 'contains',
  },
];

export const blockEventSingleOperatorOptions: {
  value: string;
  label: string;
}[] = [
  {
    value: EStringOp.CONTAINS,
    label: 'contains',
  },
];
